import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-6" };
const _hoisted_3 = { class: "col-6" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cms_block = _resolveComponent("g-cms-block");
    return (_openBlock(), _createElementBlock("article", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.getLeftContent?.config?.content)
                ? (_openBlock(), _createBlock(_component_g_cms_block, {
                    key: 0,
                    content: _ctx.getLeftContent?.config?.content
                }, null, 8, ["content"]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
            (_ctx.getRightContent?.config?.content)
                ? (_openBlock(), _createBlock(_component_g_cms_block, {
                    key: 0,
                    content: _ctx.getRightContent?.config?.content
                }, null, 8, ["content"]))
                : _createCommentVNode("", true)
        ])
    ]));
}
